import { createIdentityClient } from './identity';
import type { HttpClient } from './http';

/** End the browser session before leaving for the IdP; retain local break-glass logout on failure. */
export async function logoutBrowser(http: HttpClient, localLogout: () => Promise<void>, cleanup?: () => Promise<void>, navigate = (url: string) => location.assign(url)): Promise<void> {
  let url: string | undefined;
  try {
    try { ({ url } = await createIdentityClient(http).logout()); }
    catch { await localLogout(); }
    http.setCsrfToken(undefined);
  } finally {
    await cleanup?.();
  }
  if (url && URL.canParse(url)) {
    const target = new URL(url);
    if (target.protocol === 'https:' && !target.username && !target.password && !target.hash) navigate(target.href);
  }
}
